import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../core/store';
import { TPortState } from './portTypes';

const selectPortSlice = (state: RootState) => state.portSlice as TPortState;


export const selectPortSearchFormData = createSelector(
    [selectPortSlice],
    (portSlice) => portSlice.searchedPorts);

export const selectIsPortSearchBusy = createSelector(
    [selectPortSlice],
    (portSlice) => portSlice.isPortSearchBusy);

export const selectSelectedPortGeometry = createSelector(
    [selectPortSlice],
    (portSlice) => portSlice.selectedPortGeometry);
